import './App.css';
import LoginPage from "./Login";

function App() {
  return (
   <LoginPage />
  );
}

export default App;
